import { FC } from 'react'
import { StyleSheet, View } from 'react-native'
import { IconButton } from 'react-native-paper'
import DashSquareDisabled from '../../../../assets/icons/dash-square-disabled.svg'
import DashSquare from '../../../../assets/icons/dash-square.svg'
import PlusDisabled from '../../../../assets/icons/plus-disabled.svg'
import Plus from '../../../../assets/icons/plus.svg'
import { ColorsEnum } from '../../../constants/colors'
import ProgressBarWithQuantity from './ProgressBarWithQuantity'

interface QuantityChangerProps {
    readyQuantity: number
    totalQuantity: number
    color: string
    withQuantityChange: boolean
    isLoading: boolean
    onQuantityDecrease: () => void
    onQuantityIncrease: () => void
}

const QuantityChanger: FC<QuantityChangerProps> = ({
    readyQuantity,
    totalQuantity,
    color,
    withQuantityChange,
    isLoading,
    onQuantityDecrease,
    onQuantityIncrease,
}) => {
    const isDecreaseDisabled = readyQuantity === 0
    const isIncreaseDisabled = readyQuantity === totalQuantity

    return (
        <View style={styles.container}>
            {withQuantityChange && (
                <IconButton
                    disabled={isDecreaseDisabled || isLoading}
                    icon={!isLoading ? DashSquare : DashSquareDisabled}
                    iconColor={ColorsEnum.PRIMARY}
                    onPress={onQuantityDecrease}
                    style={[styles.button, isDecreaseDisabled && styles.buttonDisabled]}
                />
            )}
            <ProgressBarWithQuantity
                readyQuantity={readyQuantity}
                totalQuantity={totalQuantity}
                color={color}
            />
            {withQuantityChange && (
                <IconButton
                    disabled={isIncreaseDisabled || isLoading}
                    icon={!isLoading ? Plus : PlusDisabled}
                    iconColor={ColorsEnum.SECONDARY_LIGHT}
                    onPress={onQuantityIncrease}
                    style={[styles.button, isIncreaseDisabled && styles.buttonDisabled]}
                />
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    button: {
        height: 50,
        width: 58,
        margin: 0,
    },
    buttonDisabled: {
        opacity: 0,
    },
})

export default QuantityChanger
